import React from 'react';
import SplitPanel from '@amzn/uno-awsui-components-react-themed/split-panel';
import AppStore from 'container/app/appStore';

interface Props {
  appStore?: AppStore;
}

const DocSplitPanel = (props: Props) : JSX.Element => {
  const { appStore } = props;

  return (
    <>
      {appStore?.splitpanel &&
        <SplitPanel
          data-testid="action-item-split-panel"
          header={appStore?.splitPanelHeader ?? ''}
          hidePreferencesButton
          closeBehavior={appStore.actionItemsSplitpanel ? 'hide' : 'collapse'}
        >
          {appStore?.splitPanelContent}
        </SplitPanel>
      }
    </>
  );
};

export default DocSplitPanel;
